import axios, { AxiosRequestConfig, Method } from 'axios';
import { ElMessage } from 'element-plus'
import { useInfoStoreHook } from '@/stores/modules/login'
import Request from '@/api/module';
import router from "@/router";

import { setToken, removeToken, setRefreshToken ,removeReFreshToken} from "@/scripts/token";


// 定义接口
interface PendingType {
  url?: string;
  method?: Method;
  params: any;
  data: any;
  cancel: Function;
}

// 取消重复请求
const pending: Array<PendingType> = [];
const CancelToken = axios.CancelToken;
// axios 实例
const instance = axios.create({
  timeout: 60000,
  responseType: 'json',
  baseURL:'/api/'
});
// 上传拦截白名单
const whiteList = ['/organization/page'];

// 移除重复请求
const removePending = (config: AxiosRequestConfig) => {
  var url:any = config.url;
  var boolean = !!~whiteList.indexOf(url);
  if(boolean){
    return
  }
  for (const key in pending) {
    const item: number = +key;
    const list: PendingType = pending[key];
    // 当前请求在数组中存在时执行函数体
    if (
      list.url === url &&
      list.method === config.method &&
      JSON.stringify(list.params) === JSON.stringify(config.params) &&
      JSON.stringify(list.data) === JSON.stringify(config.data)
    ) {
      // 执行取消操作
      list.cancel();
      // 从数组中移除记录
      pending.splice(item, 1);
    }
  }
};

// 添加请求拦截器
instance.interceptors.request.use(
  (request) => {
    removePending(request);
    request.cancelToken = new CancelToken((c) => {
      pending.push({
        url: request.url,
        method: request.method,
        params: request.params,
        data: request.data,
        cancel: c,
      });
    });
    return request;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// 是否正在刷新的标记
let isRefreshing = false
// 重试队列，每一项将是一个待执行的函数形式
let requests:any = []
// 添加响应拦截器
// response.setHeader("X-Frame-Options", "SAMEORIGIN")// 解决IFrame拒绝的问题
instance.interceptors.response.use(
  (response) => {
    removePending(response.config);
    const status = response?.status;
    // 如果是blob, 说明是下载文件流，此时不需要判断res.status
    if (response.config.responseType === 'blob') {
      const dis = response.headers['content-disposition']
      if (dis && dis.split(';')[1].split('=')[1]) {
        const filename = decodeURIComponent(dis.split(';')[1].split('=')[1]).replace(/"/g, "")
        return Promise.resolve({ data: response.data, filename })
      } else {
        ElMessage.error('服务器繁忙,请重试！！！')
        return Promise.reject(response)
      }
      return Promise.resolve({ data: response.data })
    }
    if (status == 200) {
      if (response.data.code == '401') {
        const config:any = response.config
        let token = window.localStorage.getItem('__token__')
        let refresh_token = window.localStorage.getItem('__refreshToken__')
        if (token && refresh_token) {
          if (!isRefreshing) {
            isRefreshing = true
            return Request.getRefreshToken({refresh_token}).then(({data})=>{
              removeReFreshToken()
              setRefreshToken(data.data.refresh_token)
              removeToken()
              setToken(data.data.access_token)
              requests.forEach((cb: any) => cb(data.data.access_token))
              let Authorization: string = `Bearer ${data.data.access_token}`
              config.headers['Authorization'] = Authorization
              requests = []
              console.log(config)
              return instance(config)
            }).catch(res => {
              console.error('refreshtoken error =>', res)
            }).finally(() => {
              isRefreshing = false
            })
          } else {
            // 正在刷新token，将返回一个未执行resolve的promise
            return new Promise((resolve) => {
              // 将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
              requests.push((token:String) => {
                let Authorization: string = `Bearer ${token}`
                config.headers['Authorization'] = Authorization
                resolve(instance(config))
              })
            })
          }
        } else {
          window.location.replace('/ykindex')
        }
        return token && refresh_token ? response : Promise.reject(response)
      }
      if(response.data.code==105){
        setTimeout(()=>{
          window.location.href='/'
        },2000)
      }
      else if(response.data?.message?.indexOf('刷新失败：请重新登录')>-1){
        // window.location.href='/'
        removeToken()
        removeReFreshToken()
        router.replace('/')
        const userStore:any = useInfoStoreHook()
        //userStore.$keycloak.logout()
         // window.location.href='/'
      }else if(response.data.code==1017){
        location.reload()
      }
      return Promise.resolve(response)
    }
    return Promise.reject(response)
  },
  (error:any) => {
    const userStore:any = useInfoStoreHook()
    const response = error.response;
    if (response) {
      if(response.data?.msg){
        if(!(response.data?.message?.indexOf('获取用户ID失败')> -1)){
          // console.log(response.data.message);
          ElMessage.error(response.data.message)
        }
        else if(response.data?.message?.indexOf('刷新失败') > -1){
          // window.location.href='/'
          removeToken()
          removeReFreshToken()
          window.location.replace('/ykindex')
          //userStore.$keycloak.logout()
        }
      }
      // console.log(response?.status);
    // 根据返回的http状态码做不同的处理
    switch (response?.status) {
      case 401:
        const config:any = response.config
        let token = window.localStorage.getItem('__token__')
        let refresh_token = window.localStorage.getItem('__refreshToken__')
        if (token && refresh_token) {
          if (!isRefreshing) {
            isRefreshing = true
            return Request.getRefreshToken({refresh_token}).then(({data})=>{
              removeReFreshToken()
              setRefreshToken(data.data.refresh_token)
              removeToken()
              setToken(data.data.access_token)
              requests.forEach((cb: any) => cb(data.data.access_token))
              let Authorization: string = `Bearer ${data.data.access_token}`
              config.headers['Authorization'] = Authorization
              requests = []
              console.log(config)
              return instance(config)
            }).catch(res => {
              console.error('refreshtoken error =>', res)
            }).finally(() => {
              isRefreshing = false
            })
          } else {
            // 正在刷新token，将返回一个未执行resolve的promise
            return new Promise((resolve) => {
              // 将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
              requests.push((token:String) => {
                let Authorization: string = `Bearer ${token}`
                config.headers['Authorization'] = Authorization
                resolve(instance(config))
              })
            })
          }
        } else {
          window.location.replace('/ykindex')
        }
        return token && refresh_token ? response : Promise.reject(response || { error })
        break;
      case 403:
        // 没有权限
        break;
      case 500:
        // 服务端错误
      case 503:
        // 服务端错误
        break;
      case 504:
        // 服务端错误
        break;
      default:
        break;
    }
    // 超时重新请求
    const config = error.config;
    if(!config || !config.retry) return Promise.reject(response);
    // 全局的请求次数,请求的间隙
    const [RETRY_COUNT, RETRY_DELAY] = [0, 1000];

    if (config && RETRY_COUNT) {
      // 设置用于跟踪重试计数的变量
      config.__retryCount = config.__retryCount || 0;
      // 检查是否已经把重试的总数用完
      if (config.__retryCount >= RETRY_COUNT) {
        return Promise.reject(response || { message: error.msg });
      }
      // 增加重试计数
      config.__retryCount++;
      // 创造新的Promise来处理指数后退
      const backoff = new Promise<void>((resolve) => {
        setTimeout(() => {
          resolve();
        }, RETRY_DELAY || 1);
      });
      // instance重试请求的Promise
      return backoff.then(() => {
        return instance(config);
      });
    }
    return Promise.reject(response)
    }else{
      error.response = {}
      // ElMessage.error('系统异常，请稍后再操作')
      return Promise.reject(response)
    }
  },
);

export default instance;
